(() => {
  function initialize(root) {
    if (root.dataset.gdReady === 'true') return;
    const entries = [...root.querySelectorAll('[data-gd-entry]')];
    const groups = [...root.querySelectorAll('[data-gd-group]')];
    const controls = [...root.querySelectorAll('[data-gd-filter]')];
    if (!entries.length || !controls.length) return;
    const defaults = new Map(controls.map(control => [control.dataset.gdFilter, control.options[0].textContent]));
    const state = Object.fromEntries(controls.map(control => [control.dataset.gdFilter, '']));
    const matches = (entry, except) => Object.entries(state).every(([key, value]) => key === except || !value || entry.dataset[key] === value);
    function update() {
      for (const control of controls) {
        const key = control.dataset.gdFilter;
        const values = [...new Set(entries.filter(entry => matches(entry, key)).map(entry => entry.dataset[key]))]
          .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
        control.replaceChildren(new Option(defaults.get(key), ''), ...values.map(value => new Option(value, value)));
        control.value = state[key];
      }
      let count = 0;
      for (const entry of entries) {
        entry.hidden = !matches(entry);
        if (!entry.hidden) count++;
      }
      const filtersActive = Object.values(state).some(Boolean);
      for (const group of groups) {
        group.hidden = !group.querySelector('[data-gd-entry]:not([hidden])');
        group.open = filtersActive && !group.hidden;
      }
      root.querySelector('[data-gd-count]').textContent = root.dataset.countTemplate.replace('__COUNT__', String(count));
      root.querySelector('[data-gd-empty]').hidden = count > 0;
    }
    for (const control of controls) control.addEventListener('change', () => {
      state[control.dataset.gdFilter] = control.value;
      update();
    });
    root.querySelector('[data-gd-reset]').addEventListener('click', () => {
      Object.keys(state).forEach(key => { state[key] = ''; });
      update();
      controls[0].focus();
    });
    update();
    root.querySelector('[data-gd-filters]').hidden = false;
    root.dataset.gdReady = 'true';
  }
  document.querySelectorAll('[data-gen3-downloads]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-gen3-downloads]').forEach(initialize));
})();
